var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KButton',{attrs:{"text":"Options","hasDropdown":""},scopedSlots:_vm._u([{key:"menu",fn:function(){return [_c('KDropdownMenu',{attrs:{"hideOnClick":false,"constrainToScrollParent":false,"options":['Single Option']}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }